import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';


const CardEmployeeInfoHistoryUX = (props: any) => {
    return(
      <div
        style={{padding: "10px", lineHeight: 1.85}}>
        <div
          id="CardEmployeeInfoHistoryUX-div-1">

          <label
            id="CardEmployeeInfoHistoryUX-label-6">
            {props.data?.created || "-"}
          </label>
          <label
            id="CardEmployeeInfoHistoryUX-label-7"
            style={{marginLeft: "1rem"}}>
            {`Update By : ${props.data?.edit_user?.full_name||"-"}`}
          </label>
        </div>
        <div
          id="CardEmployeeInfoHistoryUX-div-2">

          <label
            id="CardEmployeeInfoHistoryUX-label-8"
            style={{fontWeight: props.data?.position_changed?"bold":"normal"}}>
            {`Position : `}
          </label>
          <label
            id="CardEmployeeInfoHistoryUX-label-9">
            {props.data?.positionName || "-"}
          </label>
        </div>
        <div
          id="CardEmployeeInfoHistoryUX-div-3">

          <label
            id="CardEmployeeInfoHistoryUX-label-10"
            style={{fontWeight: props.data?.affiliate_changed?"bold":"normal"}}>
            {`Department of affiliation : `}
          </label>
          <label
            id="CardEmployeeInfoHistoryUX-label-11">
            {props.data?.affiliateName || "-"}
          </label>
        </div>
        <div
          id="CardEmployeeInfoHistoryUX-div-4">

          <label
            id="CardEmployeeInfoHistoryUX-label-12"
            style={{fontWeight: props.data?.amount_changed?"bold":"normal"}}>
            {`Salary/Wages : `}
          </label>
          <label
            id="CardEmployeeInfoHistoryUX-label-13">
            {props.data?.amount || "-"}
          </label>
        </div>
        <div
          id="CardEmployeeInfoHistoryUX-div-5">

          <label
            id="CardEmployeeInfoHistoryUX-label-14"
            style={{fontWeight: props.data?.base_ot_changed?"bold":"normal"}}>
            {`Base OT : `}
          </label>
          <label
            id="CardEmployeeInfoHistoryUX-label-15">
            {props.data?.base_ot|| "-"}
          </label>
        </div>
      </div>
    )
}


export default CardEmployeeInfoHistoryUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Fri Jun 27 2025 15:14:20 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\", lineHeight: 1.85}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-div-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-div-4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-div-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.created || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-label-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "`Update By : ${props.data?.edit_user?.full_name||\"-\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-label-7"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "label",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "`Position : `"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-label-8"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: props.data?.position_changed?\"bold\":\"normal\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "label",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.positionName || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-label-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "`Department of affiliation : `"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-label-10"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: props.data?.affiliate_changed?\"bold\":\"normal\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.affiliateName || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-label-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "label",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "`Salary/Wages : `"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-label-12"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: props.data?.amount_changed?\"bold\":\"normal\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.amount || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-label-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "`Base OT : `"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-label-14"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: props.data?.base_ot_changed?\"bold\":\"normal\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.base_ot|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoHistoryUX-label-15"
        }
      },
      "seq": 15,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardEmployeeInfoHistoryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
